import React from "react";

export default ({ product }) => {
  return <img src={product.thumbnail} alt="thumbnail" />;
};
